// 存储
export function setStorage(key,value,sTime){
    let obj = {
        data: value,
        time: Date.now(),
        storageTime: sTime
    }
    window.localStorage.setItem(key, JSON.stringify(obj))
}

// 取值
export function getStorage(key){
    let obj = window.localStorage.getItem(key)
    obj = JSON.parse(obj)
    if(null==obj || (Date.now()-obj.time>obj.storageTime)){
        window.localStorage.removeItem(key);
        return null
    }
    return obj.data
}
// 删除缓存
export function removeStorage(key) {
    localStorage.removeItem(key);
}